import {CheckSquare, Square} from '@phosphor-icons/react';
import './checkbox.scss';
import {ReactNode} from "react";

interface CheckboxProps {
  active?: boolean,
  handleClick: () => void,
  text?: string,
  textHtml?: ReactNode,
  error?: boolean,
  disabled?: boolean
}

const Checkbox = (props: CheckboxProps) => {
  const {
    active,
    handleClick,
    text,
    textHtml,
    error,
    disabled
  } = props;

  return <div className={`checkbox ${disabled ? 'checkbox-disabled' : ''}`}
              onClick={!disabled ? handleClick : () => {}}>
    <span>
      {
        active
          ? <CheckSquare
            size={28}
            color={'#212121'}
          />
          : <Square
            size={28}
            color={error ? '#E81E08' : '#212121'}
          />
      }
    </span>
    {
      text
        ? <span className={'checkbox-text'}>
          {text}
        </span>
        : textHtml
          ? <span
            className={'checkbox-text'}
          >
          {textHtml}
          </span>
          : null
    }
  </div>
}
export default Checkbox;